const CENTS = 100;

export const roundToCents = (value: number): number => Math.round(value * CENTS) / CENTS;
